import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <ContactSection />
        <CommentsSection />
        <AboutSection />
        <FeaturesSection />
        <FAQSection />
        <AppSection />
        <RankingSection />
        <MediaSection />
        <IndexSection />
        <CarouselSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
      </main>

      <Footer />
    </div>
  );
}